import { v4 as uuidv4 } from 'uuid';
import useFeedbackStore from './FeedbackStore';

/**
 * Un Set para rastrear los mensajes que ya se han mostrado con '...Once'.
 * Esto previene que el mismo mensaje "Once" aparezca repetidamente.
 */
const seenMessages = new Set();

/**
 * Función helper interna para añadir un mensaje al store.
 * @param {string} type - El tipo de mensaje (success, error, etc.).
 * @param {string} message - El contenido del mensaje.
 * @param {object} options - Opciones adicionales.
 */
function addMessage(type, message, options = {}) {
  // Obtenemos la acción 'addFeedback' directamente del estado del store.
  const { addFeedback } = useFeedbackStore.getState();
  const generatedId = uuidv4();
  const feedbackMessage = { 
    id: generatedId, 
    message, 
    type, 
    time: new Date().toLocaleTimeString(),
    ...options 
  };
    /*console.log("🐞 [feedback.js] Debugging Feedback Creation:", {
    generatedId: generatedId,
    finalMessageObject: feedbackMessage
  });*/
  addFeedback(feedbackMessage);
}

/**
 * Funciones de feedback públicas
 */
export function success(message, options) {
  addMessage('success', message, options);
}

export function error(message, options) {
  addMessage('error', message, options);
}

export function warning(message, options) {
  addMessage('warning', message, options);
}

export function info(message, options) {
  addMessage('info', message, options);
}

export function log(message, options) {
  addMessage('log', message, options);
}

/**
 * Limpia todos los mensajes del historial.
 */
export function clear() {
  useFeedbackStore.getState().clearFeedback();
  seenMessages.clear(); // También limpiamos los mensajes vistos
}

/**
 * Muestra un mensaje de éxito, pero solo una vez por sesión para el mismo mensaje.
 */
export function successOnce(message, options) {
  if (!seenMessages.has(message)) {
    seenMessages.add(message);
    success(message, options);
  }
}

/**
 * Muestra un mensaje de error, pero solo una vez por sesión.
 */
export function errorOnce(message, options) {
  if (!seenMessages.has(message)) {
    seenMessages.add(message);
    error(message, options);
  }
}

/**
 * Muestra una advertencia, pero solo una vez por sesión.
 */
export function warningOnce(message, options) {
  if (!seenMessages.has(message)) {
    seenMessages.add(message);
    warning(message, options);
  }
}

/**
 * Muestra un mensaje de información, pero solo una vez por sesión.
 */
export function infoOnce(message, options) {
  if (!seenMessages.has(message)) {
    seenMessages.add(message);
    info(message, options);
  }
}

/**
 * Muestra un log, pero solo una vez por sesión.
 */
export function logOnce(message, options) {
  if (!seenMessages.has(message)) {
    seenMessages.add(message);
    log(message, options);
  }
}

// Exportamos un objeto que contiene todas las funciones para un uso conveniente.
const feedback = {
  success,
  error,
  warning,
  info,
  log,
  clear,
  successOnce,
  errorOnce,
  warningOnce,
  infoOnce,
  logOnce,
};

export default feedback;
